// @flow
import React from 'react';
import styles from './EnvironmentBanner.module.scss';

// Renders a prominent banner only when running against the staging
// environment (driven by REACT_APP_ENV in .env.staging). Production builds
// do not set this flag, so nothing renders there.
export default function EnvironmentBanner() {
  if (process.env.REACT_APP_ENV !== 'staging') {
    return null;
  }

  return (
    <div className={styles.banner} role="alert">
      <span role="img" aria-label="Warning">
        ⚠️
      </span>{' '}
      STAGING ENVIRONMENT — test data only, not production
    </div>
  );
}
